import { useState } from "react";
import { Box } from "@mui/system";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { BRAND_STATUS_LABELS } from "./utils/helpersOfBrands";

interface Props {
  rows: any[];
  selectedStatus: string[] | null;
  setSelectedStatus: (value: string[] | null) => void;
  selectedAccountStatus: string[] | null;
  setSelectedAccountStatus: (value: string[] | null) => void;
  selectedAffiliateSystem: string[] | null;
  setSelectedAffiliateSystem: (value: string[] | null) => void;
  selectedCompany: string[] | null;
  setSelectedCompany: (value: string[] | null) => void;
  selectedWebsite: string[] | null;
  setSelectedWebsite: (value: string[] | null) => void;
  clearFilters: () => void;
}

// Status / Account Additional Status / Affiliate System / Company / Website
// quick filters, wired through the shared FilterComponent, exactly like
// BrandsFilter.tsx does for the legacy brand_data module. Used by the All
// Brands tab.
const BrandsFilterItems = ({
  rows,
  selectedStatus,
  setSelectedStatus,
  selectedAccountStatus,
  setSelectedAccountStatus,
  selectedAffiliateSystem,
  setSelectedAffiliateSystem,
  selectedCompany,
  setSelectedCompany,
  selectedWebsite,
  setSelectedWebsite,
  clearFilters,
}: Props) => {
  const [searchStatus, setSearchStatus] = useState("");
  const [searchAccountStatus, setSearchAccountStatus] = useState("");
  const [searchAffiliateSystem, setSearchAffiliateSystem] = useState("");
  const [searchCompany, setSearchCompany] = useState("");
  const [searchWebsite, setSearchWebsite] = useState("");

  const filterConfig = [
    {
      key: "Status",
      name: "Status",
      label: "Select a Status",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStatus(e.target.value),
      selectedOption: selectedStatus,
      filterName: "status",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedStatus(updatedSelection),
      count: selectedStatus?.length ?? 0,
      colorSelected:
        selectedStatus && selectedStatus.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: false,
      valueMapping: BRAND_STATUS_LABELS,
    },
    {
      // Options come straight from the API's account_status_name (the same
      // value shown under the Status badge on Account Issue rows).
      key: "AccountAdditionalStatus",
      name: "Account Additional Status",
      label: "Select one Account Additional Status or more",
      searchTerm: searchAccountStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAccountStatus(e.target.value),
      selectedOption: selectedAccountStatus,
      filterName: "account_status_name",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedAccountStatus(updatedSelection),
      count: selectedAccountStatus?.length ?? 0,
      colorSelected:
        selectedAccountStatus && selectedAccountStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AffiliateSystem",
      name: "Affiliate System",
      label: "Select one Affiliate System or more",
      searchTerm: searchAffiliateSystem,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAffiliateSystem(e.target.value),
      selectedOption: selectedAffiliateSystem,
      filterName: "affiliate_system",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedAffiliateSystem(updatedSelection),
      count: selectedAffiliateSystem?.length ?? 0,
      colorSelected:
        selectedAffiliateSystem && selectedAffiliateSystem.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Company",
      name: "Company",
      label: "Select one Company or more",
      searchTerm: searchCompany,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCompany(e.target.value),
      selectedOption: selectedCompany,
      filterName: "company_name",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedCompany(updatedSelection),
      count: selectedCompany?.length ?? 0,
      colorSelected:
        selectedCompany && selectedCompany.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
      isLongText: true,
    },
    {
      key: "Website",
      name: "Website",
      label: "Select one Website or more",
      searchTerm: searchWebsite,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchWebsite(e.target.value),
      selectedOption: selectedWebsite,
      filterName: "website_name",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedWebsite(updatedSelection),
      count: selectedWebsite?.length ?? 0,
      colorSelected:
        selectedWebsite && selectedWebsite.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  return (
    <Box data-tracker="621">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default BrandsFilterItems;
